import { ResolverTag } from '@ps/web-core-enums';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useSearchParams from '@swf/core/hooks/useSearchParams';
import type { RootState } from '@swf/core/store';
import { HowItWorksModal, useResolvedLink } from '@swf/poker';

import { usePokerSpinAndGoWidget } from '../../../model';
import type { GameTypeName } from '../../../types/Game';

import { getCarouselData } from './carouselData';

interface Props {
  gameType: GameTypeName;
  widgetId: string;
  isSharedLiquidityEnabled: boolean;
}

const HowItWorks: React.FC = () => {
  const howItWorksLink = useResolvedLink(ResolverTag.SaGGameRules);
  const { gameType, widgetId, isSharedLiquidityEnabled } = useSearchParams<Props>();
  const { widgetSelect } = usePokerSpinAndGoWidget(widgetId);
  const game = useSelector((state: RootState) => widgetSelect.highestValueGame(state, gameType));
  const topPrizeGame = useSelector((state: RootState) =>
    widgetSelect.topPrizeGame(state, gameType)
  );
  const topPrize = topPrizeGame?.winUpTo;

  const activeSlide = useMemo(
    () => getCarouselData({ gameType, topPrize, game, isSharedLiquidityEnabled, widgetId }),
    [gameType, topPrize, game, isSharedLiquidityEnabled, widgetId]
  );

  return <HowItWorksModal activeSlide={activeSlide} howItWorksLink={howItWorksLink} />;
};
export default HowItWorks;
